module.exports = __webpack_public_path__ + "static/RalewayMedium-430a0518f5ff3b6c8968b759a29b36e2.ttf";